import { render } from "./BrightBackMenu.vue?vue&type=template&id=1e6e34b2&scoped=true"
import script from "./BrightBackMenu.vue?vue&type=script&lang=js"
export * from "./BrightBackMenu.vue?vue&type=script&lang=js"

import "./BrightBackMenu.vue?vue&type=style&index=0&id=1e6e34b2&scoped=true&lang=css"

import exportComponent from "/Users/cb-it-01-1886/Documents/Chargbe Design/cb-payments-vue/cb-payments-dash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6e34b2"]])

export default __exports__